// extracted by css-extract-rspack-plugin
export default {"highlight":"nJ32l","block":"J1eMv","inline":"AlgEh"};